import React, { useState, useEffect, useRef } from 'react';
import UserMessage from './UserMessage';
import SenderMessage from './SenderMessage';
import { db } from '../../firebase';
import { collection, query, orderBy, limit, onSnapshot, addDoc, serverTimestamp, updateDoc, doc, deleteDoc } from "firebase/firestore";
import { useSelector } from 'react-redux';
import { AiOutlineSend } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import axios from 'axios';
import key from '../../key';
import { useCookies } from 'react-cookie';

const ChatComponent = ({ item, showChat, setShowChat, id, i, updateUnreadMessages }) => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const userId = useSelector((state) => state.user.user.userId);
  const receiverId = item.userId;
  const chatId = [userId, receiverId].sort().join('-');
  const messagesEndRef = useRef(null);
  const [show, setShow] = useState(false);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  //eslint-disable-next-line
  const [cookies] = useCookies(['x-auth-token']);

  const handleMessageSubmit = async (e) => {
    e.preventDefault();
    setInputValue('');
    if (inputValue.trim() !== '') {
      const newMessage = {
        content: inputValue,
        createdAt: serverTimestamp(),
        sender: userId,
        receiver: receiverId,
      };
      await addDoc(collection(db, chatId), newMessage);
      await axios.put(`${key}/api/user/unread-message`, { userId: receiverId });
      setMessages([...messages, newMessage]);
    }
  };

  const updateReadMessage = async (message) => {
    await updateDoc(doc(db, chatId, message.id), { isRead: true });
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleMessageSubmit(e);
      return;
      // if (e.ctrlKey) {
      //   const lines = inputValue.split('\n');
      //   if (lines.length >= 2 && lines[lines.length - 2].trim() === '') {
      //     handleMessageSubmit(e);
      //   }
      // } else {
      //   setInputValue((prevInputValue) => prevInputValue + '\n');
      // }
    }
  };

  // to get messages from firebase
  useEffect(() => {
    const q = query(
      collection(db, chatId),
      orderBy("createdAt"),
      limit(51)
    );
    const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
      let messages = [];
      QuerySnapshot.forEach((doc) => {
        messages.push({ ...doc.data(), id: doc.id });
      });
      setMessages(messages);
      if (messages.length > 49) {
        const messagesToDelete = messages.slice(0, 1);
        messagesToDelete.forEach(async (message) => {
          await deleteDoc(doc(db, chatId, message.id));
        }
        )
      }
    });
    return () => unsubscribe();
    //eslint-disable-next-line
  }, [chatId]);

  // show latest message date and content in parent chat widget with notification count
  useEffect(() => {
    if (messages.length > 0) {
      messages.forEach((message) => {
        if (message.receiver === userId && !message.isRead) {
          setUnreadMessageCount(messages.filter((message) => message.receiver === userId && !message.isRead).length);
          updateReadMessage(message);
        }
      }
      )

      updateUnreadMessages(i, messages[messages.length - 1]?.createdAt, messages[messages.length - 1]?.content, unreadMessageCount);
    }
    //eslint-disable-next-line
  }, [receiverId, messages]);



  // to scroll to bottom when new message is added
  useEffect(() => {
    scrollToBottom();
    //eslint-disable-next-line
  }, [messages]);

  // to scroll to bottom when chat is opened
  useEffect(() => {
    if (showChat === receiverId) {
      scrollToBottom();
    }
    //eslint-disable-next-line
  }, [showChat, receiverId, show]);


  // to show and close chat on click
  useEffect(() => {
    if (showChat === receiverId) {
      setShow(true);
    } else {
      setShow(false);
    }

    //eslint-disable-next-line
  }, [showChat, receiverId]);


  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'auto', block: 'end' });
  };

  return show ? (
    <div className='chat-component'>
      <div className='d-flex justify-content-between text-white chat-header'>
        <Link to={`/view-profile/${id}`}>{item.name}</Link>
        {/* <button onClick={handleClose}><AiOutlineClose /></button> */}
      </div>
      <div className="chat-body" style={{ overflowY: 'auto', minHeight: 'calc(100vh - 230px)' }}>
        {messages.map((message, index) =>
          message.sender === userId ? (
            <div key={index} className='d-flex justify-content-end'>
              <UserMessage key={message.id} message={message} />
            </div>
          ) : (
            <SenderMessage key={message.id} message={message} />
          )
        )}
        <div ref={messagesEndRef} />
      </div>
      <form onSubmit={handleMessageSubmit}>
        <div className='d-flex justify-content-between chat-footer'>
          <textarea
            className="chat-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Enter your message"
          ></textarea>
          <button type="submit" ><AiOutlineSend /></button>
        </div>
      </form>
    </div>
  ) : null;
};

export default ChatComponent;
